import { Typography } from "antd";
import { getFullName } from "../../../../../utils/shared";

const { Link } = Typography;

// All regex at module level — compiled once, never recreated
const SPLIT_REGEX =
  /(<@[\w-]+>|(?:https?:\/\/|www\.)\S+|[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+\.[a-zA-Z]{2,}(?:\/\S*)?)/g;

const MENTION_REGEX = /^<@([\w-]+)>$/;

const URL_REGEX =
  /^(?:https?:\/\/|www\.)\S+|^[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+\.[a-zA-Z]{2,}/;

const HTTP_PREFIX_REGEX = /^https?:\/\//i;

export const renderContentWithLinks = ({ text, users, showLink = true }) => {
  // Early return — skip all work for empty input
  if (!text) return "";

  // Build map once per call; skip entirely if users is empty/null
  const userMap =
    users?.length > 0
      ? new Map(users.map((u) => [u.id, getFullName(u)]))
      : null;

  const parts = text.split(SPLIT_REGEX);
  const result = [];

  for (let i = 0; i < parts.length; i++) {
    const part = parts[i];

    // Skip empty strings without a filter pass
    if (!part) continue;

    // Mention: <@uuid>
    const mentionMatch = part.match(MENTION_REGEX);
    if (mentionMatch) {
      const name = userMap?.get(mentionMatch[1]);
      result.push(
        <span key={i} className="mention-user-name">
          @{name ?? mentionMatch[1]}
        </span>,
      );
      continue;
    }

    // URL — test before building href string
    if (URL_REGEX.test(part) && showLink) {
      const href = HTTP_PREFIX_REGEX.test(part) ? part : `https://${part}`;
      result.push(
        <Link
          key={i}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary"
        >
          {part}
        </Link>,
      );
      continue;
    }

    // Plain text
    result.push(part);
  }

  return result;
};
